module.exports = __webpack_public_path__ + "img/carrousel-flatpanel-6.c1b17e5f.png";